'use client';

const Page = () => {
  return (
    <>
      <div className="tw-flex tw-flex-col tw-w-full tw-p-2.4">
        <h1 className="tw-font-h1 tw-mb-0.8 tw-text-primary-main tw-mt-4">
          Welcome to the Talent Microfrontend 😼
        </h1>
        <div>
          <h2 className="tw-font-h4 tw-mt-2.4">Actions</h2>
          <button
            className="tw-btn-primary-s tw-flex-shrink-0"
            type="button"
            onClick={() => {
              const error = `${new Date().toISOString()}- Sentry frontend error example`;
              throw new Error(error);
            }}
          >
            Throw an error to test our sentry configuration (only works in
            production)
          </button>
        </div>
      </div>
    </>
  );
};

export default Page;
